/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { font } from '@exo/frontend-common-style-utils';

type Props = {
  overlay: string;
  background: string;
  formElementBackground: string;
  titleFont: string;
  secondaryButtonColor: string;
  secondaryButtonBgColorHover: string;
  primaryButtonBgColor: string;
  primaryButtonBgColorHover: string;
};

declare global {
  interface EXOComponentStyles {
    base_modal?: Partial<Props>;
  }
}

export default (props: EXOThemeProps): Props => {
  return {
    // Default theme
    overlay: props.theme.colors.backgrounds.overlay,
    background: props.theme.colors.backgrounds.panels.primary.base,
    formElementBackground: props.theme.colors.form.field.onPanel.bg,
    titleFont: font(props.theme.typography.heading.heading3),
    secondaryButtonColor: '#535353',
    secondaryButtonBgColorHover: '#e5e5e5',
    primaryButtonBgColor: '#8E65B6',
    primaryButtonBgColorHover: '#71509b',

    ...props.theme?.byComponent?.base_modal
  };
};
